import api from './api';

export interface CompanyInfo {
  orgCode: string;
  companyName: string;
  dlpUseYn: string;
  nacUseYn: string;
  aptUseYn: string;
}

export const companyService = {
  getAll: async (): Promise<CompanyInfo[]> => {
    const response = await api.get<CompanyInfo[]>('/company');
    return response.data;
  },

  getByPageType: async (pageType: 'DLP' | 'NAC' | 'APT'): Promise<CompanyInfo[]> => {
    const response = await api.get<CompanyInfo[]>(`/company/page-type/${pageType}`);
    return response.data;
  },
};

